// CountPicker.tsx — widget del step 'count'.
// Qué hace: botones de cantidad de posts por plataforma (1/2/3/5/10).
// Qué exporta: CountPicker.
// Quién lo usa: NovahGenerateChat.

import { WidgetWrap, CountGrid, CountBtn } from '../styled';

interface Props {
  confirmCount: (n: number) => void;
}

export function CountPicker({ confirmCount }: Props) {
  return (
    <WidgetWrap>
      <CountGrid>
        {[1, 2, 3, 5, 10].map((n) => (
          <CountBtn key={n} $active={false} onClick={() => confirmCount(n)}>
            {n}
          </CountBtn>
        ))}
      </CountGrid>
    </WidgetWrap>
  );
}
